<template>
  <!-- mb-2 used instead of mt-2 as don't have to check for the first case -->
  <div class="border border-solid rounded-full border-gray text-gray p-2
    hover:cursor-pointer hover:border-focus hover:bg-focus hover:text-white max-w-full"
      :class="caseClasses()"
      @click.stop="selectCase"
      @mouseover="isHover = true"
      @mouseleave="isHover = false"
  >
    <condition-case-label :condition="condition" class="test-condition-case" :is-selected="isSelected" :is-hover="isHover"/>
  </div>
</template>

<script>
import ConditionCaseLabel from '@/components/editor/condition/ConditionCaseLabel'
import { EXPRESSION_TYPES } from '@/utils/bot-json.constants'

export default {
  name: 'ConditionCase',
  components: { ConditionCaseLabel },

  props: {
    condition: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    isConditionFocused: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isHover: false,
      EXPRESSION_TYPES
    }
  },

  methods: {
    caseClasses() {
      if (this.isSelected && this.isConditionFocused) {
        return ['bg-focus', 'text-white', 'border-focus']
      }

      if (this.isSelected) {
        return ['bg-gray', 'text-white']
      }

      return []
    },

    selectCase() {
      this.$emit('select-case')
    }
  }
}
</script>
